import { Key } from 'react'
import PdMedia from '../pd-media/pd-media'
import TitleBar, { TitleBarTheme } from './title-bar'
import { HeadingTag } from '../../common/pd-meta-components-types'

type DesignAestheticsProps = {
  title: string[]
  desc?: string[]
  descInline?: boolean
  lightBGC?: string
  data: { mediaUri: string; mediaClassName?: string; mediaStyle?: { [key in string]: Key } }[]
  theme?: TitleBarTheme
  enableHoverScale?: boolean
  mediasClass?: string
  titleTag?: HeadingTag
}

const DesignAesthetics: React.FC<DesignAestheticsProps> = ({
  title,
  desc,
  data,
  descInline,
  lightBGC,
  theme = TitleBarTheme.black,
  enableHoverScale,
  mediasClass,
  titleTag,
}) => {
  return (
    <div
      className={[
        theme === TitleBarTheme.black ? 'bg-black' : lightBGC || 'bg-white',
        'w-full h-fit py-15 px-6',
        'laptop:pt-30 laptop:pb-0 laptop:px-0',
      ].join(' ')}
    >
      {title && (
        <TitleBar
          title={title}
          desc={desc}
          descInline={descInline}
          theme={theme === TitleBarTheme.black ? TitleBarTheme.white : TitleBarTheme.black}
          titleTag={titleTag}
        />
      )}
      <div className={['w-full grid grid-cols-1 gap-y-8', 'laptop:gap-0 laptop:grid-cols-3', mediasClass].join(' ')}>
        {data?.map((item, index) => (
          <div style={{ ...item?.mediaStyle }} key={index} className={[item?.mediaClassName].join(' ')}>
            <PdMedia src={item.mediaUri} mask={false} enableHoverScale={enableHoverScale} />
          </div>
        ))}
      </div>
    </div>
  )
}
export default DesignAesthetics
